module.exports = __webpack_public_path__ + "static/media/arrow-up-green.1d44c281.svg";